/* generated using openapi-typescript-codegen -- do not edit */

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import type { ModelSettingsSet } from "./ModelSettingsSet"

export type ModelListCreate = {
  readonly uuid: string
  readonly project: string
  readonly organization: string
  readonly created_by: string
  readonly created_at: string
  /**
   * Defaults to the live model's active_settings_set if the created model isn't live.Not needed for non-classification models.
   */
  active_settings_set?: ModelSettingsSet | null
  name: string
  /**
   * * `custom` - Custom
   * * `prebuilt` - Prebuilt
   * * `automl` - AutoML
   */
  readonly type: ModelListCreate.type
  /**
   * * `live` - live
   * * `challenger` - challenger
   * * `disabled` - disabled
   */
  state: ModelListCreate.state
  image_url: string
  exposed_port: number
  readonly is_ml_service_created: boolean
  /**
   * * `kcr` - kcr
   * * `private registry` - private registry
   * * `dockerhub` - dockerhub
   */
  readonly container_registry: ModelListCreate.container_registry
  readonly registry_url: string
  readonly image_name: string
  readonly image_tag: string
  training_data?: string
}
export namespace ModelListCreate {
  /**
   * * `custom` - Custom
   * * `prebuilt` - Prebuilt
   * * `automl` - AutoML
   */
  export enum type {
    CUSTOM = "custom",
    PREBUILT = "prebuilt",
    AUTOML = "automl",
  }
  /**
   * * `live` - live
   * * `challenger` - challenger
   * * `disabled` - disabled
   */
  export enum state {
    LIVE = "live",
    CHALLENGER = "challenger",
    DISABLED = "disabled",
  }
  /**
   * * `kcr` - kcr
   * * `private registry` - private registry
   * * `dockerhub` - dockerhub
   */
  export enum container_registry {
    KCR = "kcr",
    PRIVATE_REGISTRY = "private registry",
    DOCKERHUB = "dockerhub",
  }
}
